import React, { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { enqueueSnackbar } from "notistack";
import {
  styled,
  useMediaQuery,
  Drawer,
  Box,
  Typography,
  IconButton,
  Divider,
  TextField,
  Modal,
  Paper,
  Grid,
} from "@mui/material";
import {
  Close as CloseIcon,
  DoNotDisturbOn as DoNotDisturbOnIcon,
} from "@mui/icons-material";
import ButtonBlue from "../../../shared/buttonBlue/index.js";
import SiteService from "../../../../../services/site.service.js";

const ModalStyled = styled(Modal)(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));

const DrawerSite = ({
  isOpen,
  onClose,
  setAllSite,
  setAllSiteLocations,
  setIsSiteDrawerOpen,
  siteId,
  siteName,
  isEditSite,
  selectedCompanyId,
  selectedCompany,
}) => {
  const [openWarningModal, setOpenWarningModal] = React.useState(false);
  const [selectedSiteToDelete, setSelectedSiteToDelete] = React.useState(null);

  const { control, getValues, reset, setValue, watch } = useForm({
    defaultValues: {
      site: siteName,
    },
  });
  const isDrawerFullWidthScreen = useMediaQuery((theme) =>
    theme.breakpoints.down("sm")
  );

  useEffect(() => {
    if (!isOpen) {
      reset();
    } else if (isOpen) {
      setValue("site", siteName);
    }
  }, [isOpen, reset, isEditSite, siteName]);

  const handleDeleteSite = async (idSite) => {
    try {
      const res = await SiteService.deleteSite(idSite);
      if (res.data) {
        setIsSiteDrawerOpen(false);
        const res = await SiteService.getAllSites(selectedCompanyId);
        const resLocation = await SiteService.getAllSiteLocations(
          selectedCompanyId
        );
        if (res.data && resLocation.data) {
          setAllSite(res.data);
          setAllSiteLocations(resLocation.data);
        }
        enqueueSnackbar("ลบข้อมูลสำเร็จ", { variant: "success" });
      } else {
        enqueueSnackbar("ลบข้อมูลล้มเหลว", { variant: "error" });
      }
    } catch (error) {
      enqueueSnackbar("เกิดข้อผิดพลาดในการลบข้อมูล", { variant: "error" });
    }
  };

  const handleOpenWarningModal = (idSite) => {
    setSelectedSiteToDelete(idSite);
    setOpenWarningModal(true);
  };

  const handleConfirmDelete = async () => {
    if (selectedSiteToDelete) {
      await handleDeleteSite(selectedSiteToDelete);
      setSelectedSiteToDelete(null);
    }
    setOpenWarningModal(false);
  };

  const handleCloseWarningModal = () => {
    setOpenWarningModal(false);
    setSelectedSiteToDelete(null);
  };

  const handleSaveSiteName = async () => {
    const formData = getValues();

    try {
      if (isEditSite) {
        const res = await SiteService.setSite({
          siteName: formData.site,
          idSite: siteId,
        });

        if (res.data) {
          setIsSiteDrawerOpen(false);
          const fetchData = async () => {
            const res = await SiteService.getAllSites(selectedCompanyId);
            const resLocation = await SiteService.getAllSiteLocations(
              selectedCompanyId
            );
            if (res.data && resLocation.data) {
              setAllSite(res.data);
              setAllSiteLocations(resLocation.data);
            }
          };
          fetchData();
          enqueueSnackbar("บันทึกข้อมูลสำเร็จ", { variant: "success" });
        }
      } else {
        const res = await SiteService.addSite({
          siteName: formData.site,
          idCompany: selectedCompanyId,
          companyShortName: selectedCompany,
        });

        if (res.data) {
          setIsSiteDrawerOpen(false);
          const fetchData = async () => {
            const res = await SiteService.getAllSites(selectedCompanyId);
            if (res.data) {
              setAllSite(res.data);
            }
          };
          fetchData();
          enqueueSnackbar("บันทึกข้อมูลสำเร็จ", { variant: "success" });
        }
      }
    } catch (error) {
      enqueueSnackbar("บันทึกข้อมูลล้มเหลว", { variant: "error" });
    }
  };

  return (
    <Box>
      <Drawer
        anchor="right"
        open={isOpen}
        onClose={onClose}
        sx={{ zIndex: 1300 }}
      >
        <Box sx={{ width: { xs: "100vw", sm: 598 }, position: "relative" }}>
          <Typography sx={{ padding: "16px" }}>
            {isEditSite ? `แก้ไข SITE ${siteName}` : "เพิ่ม SITE"}
          </Typography>
          {isDrawerFullWidthScreen && (
            <IconButton
              onClick={onClose}
              sx={{ position: "absolute", top: 8, right: 8 }}
            >
              <CloseIcon />
            </IconButton>
          )}
          <Divider />
          <Box
            sx={{
              padding: "24px",
              display: "flex",
              flexDirection: "column",
              gap: "16px",
            }}
          >
            {isEditSite && (
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <ButtonBlue
                  variant="contained"
                  startIcon={<DoNotDisturbOnIcon />}
                  customColor="#F44336"
                  sx={{
                    "&:hover": {
                      borderColor: "#d9392e",
                      backgroundColor: "#d9392e",
                    },
                  }}
                  onClick={() => handleOpenWarningModal(siteId)}
                  // onClick={() => {
                  //   handleDeleteSite(siteId);
                  // }}
                >
                  ลบ SITE
                </ButtonBlue>
              </Box>
            )}
            <Typography
              variant="subtitle1"
              sx={{ color: "#637381 !important", fontWeight: 600 }}
            >
              ชื่อ/หมายเลข SITE
            </Typography>
            <Controller
              name="site"
              control={control}
              defaultValue={isEditSite ? siteName : ""}
              render={({ field }) => (
                <TextField
                  {...field}
                  InputProps={{ style: { borderRadius: "10px" } }}
                  fullWidth
                  multiline
                  rows={2}
                />
              )}
            />
            <Box sx={{ display: "flex", justifyContent: "end", gap: "16px" }}>
              <ButtonBlue variant="outlined" onClick={onClose}>
                ยกเลิก
              </ButtonBlue>
              <ButtonBlue variant="contained" onClick={handleSaveSiteName} disabled={watch("site") ? false : true}>
                บันทึกข้อมูล
              </ButtonBlue>
            </Box>
          </Box>
        </Box>
      </Drawer>
      <ModalStyled
        open={openWarningModal}
        onClose={handleCloseWarningModal}
        sx={{
          width: "100%",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Paper
          sx={{
            boxShadow: 24,
            p: 4,
            borderRadius: "8px",
            textAlign: "center",
          }}
        >
          <Grid container>
          <Grid item xs={12} sm={12}>
            <Typography variant="h6" sx={{ mb: 2 }}>
              {`ยืนยันการลบ SITE ${siteName}`}
            </Typography>
            <Typography sx={{ mb: 3 }}>
              หากคุณลบ SITE นี้ ข้อมูลทั้งหมดจะหายไปและไม่สามารถกู้คืนได้
            </Typography>
            <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
              <ButtonBlue onClick={handleConfirmDelete}>ยืนยัน</ButtonBlue>
              <ButtonBlue onClick={handleCloseWarningModal} color="error">
                ยกเลิก
              </ButtonBlue>
            </Box>
          </Grid>
          </Grid>
        </Paper>
      </ModalStyled>
    </Box>
  );
};

export default DrawerSite;
